/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Maturity_FcInputs */

const en_fc_cmp_maturity_fc = /** @type {(inputs: Fc_Cmp_Maturity_FcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alpha (~56% production-ready, self-reported)`)
};

/**
* | output |
* | --- |
* | "Alpha (~56% production-ready, self-reported)" |
*
* @param {Fc_Cmp_Maturity_FcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_maturity_fc = /** @type {((inputs?: Fc_Cmp_Maturity_FcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Maturity_FcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_maturity_fc(inputs)
});
export { fc_cmp_maturity_fc as "fc.cmp.maturity.fc" }